import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http'
import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideRouter, TitleStrategy } from '@angular/router'
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core'
import { routes } from './app-routing.module'
import { AuthInterceptorService } from '@services/auth-interceptor.service'
import { GlobalErrorHandler } from '@services/global-error-handler.service'
import { MultiTranslateHttpLoader } from '@services/multi-http-loader'
import { LocalizedTitleStrategy } from '@services/localized-title.strategy'
import { provideEffects } from '@ngrx/effects'
import { ActionReducer, MetaReducer, provideStore } from '@ngrx/store'
import { localStorageSync } from 'ngrx-store-localstorage'

export function HttpLoaderFactory(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, './assets/i18n/', '.json')
}

export function localStorageSyncReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return localStorageSync({
    keys: [
      {
        user: {
          serialize: (state: any) => ({
            currentUser: state.currentUser
              ? { id: state.currentUser.id, role: state.currentUser.role }
              : null,
          }),
        },
      },
    ],
    rehydrate: true,
  })(reducer)
}

export const metaReducers: MetaReducer<any>[] = [localStorageSyncReducer]

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    { provide: TitleStrategy, useClass: LocalizedTitleStrategy },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideStore({}, { metaReducers }),
    provideEffects(),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    TranslateService,
  ],
}
